import BaseStyle from 'primevue/base/style';

var classes = {
  root: 'p-inputgroup'
};
var InputGroupStyle = BaseStyle.extend({
  name: 'inputgroup',
  classes: classes
});

export { InputGroupStyle as default };
